<template>
    <div
        class="d-flex flex-column flex-shrink-0 p-2 bg-primary sidebar-a"
        :style="'width: ' + width + 'px;'"
        @mouseover="autoExpand = true"
        @mouseleave="autoExpand = false"
    >
        <ul class="nav nav-pills flex-column mb-auto nav-sidebar">
            <li v-if="allowManualShow">
                <a
                    class="nav-link text-white px-0 d-flex align-items-center"
                    @click="handleShowHideButton(autoExpand, manualExpand)"
                >
                    <i class="fa-solid fa-bars fa-2x icon"></i>
                    <label
                        v-if="!minimalized"
                        class="ms-2"
                        >Menu verbergen</label
                    >
                </a>
            </li>
            <li
                v-for="navitem in navitems"
                :key="navitem.label"
                class="nav-item"
            >
                <!-- Single nav items -->
                <router-link
                    v-if="navitem.route"
                    :to="navitem.route"
                    class="nav-link text-white px-0 d-flex align-items-center"
                    :class="{
                        active: $route.name == navitem.route.name,
                        disabled: navitem.disabled,
                    }"
                >
                    <i
                        class="fa-solid fa-2x icon"
                        :class="navitem.icon"
                    ></i>
                    <span
                        v-if="!minimalized"
                        class="ms-2 h-100"
                        >{{ navitem.label }}</span
                    >
                </router-link>

                <!-- Group nav items -->
                <SidebarNavGroup
                    v-else
                    :navitem="navitem"
                    :minimalized="minimalized"
                />
            </li>
        </ul>
    </div>
</template>

<style scoped>
.icon {
    width: 40px;
    text-align: center;
}

.sidebar-a {
    transition: width 0.5s;
    transition-timing-function: ease;
    overflow-y: auto;
}

.sidebar-a span {
    text-wrap: nowrap;
    overflow: hidden;
}
</style>

<script>
import SidebarNavGroup from "./SidebarNavGroup.vue";
import { getNavItems } from "@helpers/navitems";
import isTouchScreen from "@helpers/touchscreen";
import { useUserStore } from "@stores/userStore";

export default {
    name: "Sidebar",
    components: { SidebarNavGroup },
    setup() {
        const userStore = useUserStore();
        return { userStore };
    },
    data() {
        return {
            allowManualShow: false,
            autoExpand: false,
            manualExpand: false,
            navitems: getNavItems(),
        };
    },
    watch: {
        // Close sidebar when user permissions change
        "userStore.permissions"() {
            this.navitems = getNavItems();
        },
    },
    computed: {
        minimalized() {
            return !(this.autoExpand || this.manualExpand);
        },
        width() {
            return this.minimalized ? 60 : 280;
        },
    },
    mounted() {
        this.allowManualShow = isTouchScreen;
    },
    methods: {
        handleShowHideButton(autoExpand, manualExpand) {
            // Close sidebar when manually opened
            if (manualExpand) {
                this.manualExpand = false;
                this.autoExpand = false;
                return;
            }

            // Close sidebar when automatically opened
            if (autoExpand) {
                this.autoExpand = false;
                return;
            }

            // Open sidebar
            this.manualExpand = true;
        },
    },
};
</script>
